var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import Signals from '../../signals/Signals';
import updateUserRole from '../../requests/organisation/updateUserRole';
import History from '../../services/History';
import Routes from '../../routes/RoutesConfig';
var UpdateUserRoleCommand = /** @class */ (function (_super) {
    __extends(UpdateUserRoleCommand, _super);
    function UpdateUserRoleCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UpdateUserRoleCommand.prototype.execute = function (organisationId, user, targetUserRole, intl) {
        this.intl = intl;
        this.organisationId = organisationId;
        this.userId = user.id;
        this.role = targetUserRole;
        var promise = updateUserRole(this.organisationId, this.userId, this.role);
        promise.then(this.then);
        promise.catch(this.catch);
        return promise;
    };
    UpdateUserRoleCommand.prototype.then = function (response) {
        //show error notification
        History.replace(Routes.USERS.path);
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'page.users.upgraderole.notification' }, Object(this.user)), 'dark', true);
    };
    return UpdateUserRoleCommand;
}(Command));
export default UpdateUserRoleCommand;
